/** token 失效：App 通知原生，H5 清缓存并刷新 */
function handleTokenExpired() {
  if (window.$store?.isApp) {
    window.AIOTBridge?.tokenExpired?.()
    return
  }
  window.$message?.error('登录已过期，请重新登录')
  localStorage.clear()
  window.location.reload()
}

class Request {


  constructor(baseURL, prefixURL = '') {
    this.baseURL = baseURL + prefixURL
    this.defaultHeaders = {
      'Content-Type': 'application/json'
    }
  }

  async request(url, options = {}) {
    const finalUrl = this.baseURL + url
    const token = localStorage.getItem('token') || ''
    const headers = {
      ...this.defaultHeaders,
      ...options.headers
    }

    if (token) headers.authorization = token

    const config = {
      ...options,
      headers
    }
    
    if (options.isUpload) {
        if (config.headers && config.headers instanceof Headers) {
          config.headers.delete('Content-Type');
        } else if (config.headers && typeof config.headers === 'object') {
          delete config.headers['Content-Type'];
        }
    }
    try { 
      const response = await fetch(finalUrl, config)
      if( !response.ok ) {
        let text = await response.text()
        const msg = text ? JSON.parse(text).message || JSON.parse(text).error : '接口请求失败'
        if(msg === '无效的权限请求头') {
          handleTokenExpired()
          return
        }
        return window.$message.error(msg)
      }
      // 自动解析 JSON
      // 自动解析响应，支持 JSON / Blob / 文本
      const contentType = response.headers.get('Content-Type') || ''
      let result
      if (options.responseType === 'blob') {
        result = {
          code: 200,
          message: 'success',
          data: await response.blob(),
          contentType
        }
      } else if (contentType.includes('application/json')) {
        let r =  await response.json()
        if( r.code ) {
          result = r
        } else {
          // 文件流返回的内容没有包裹在data中，直接返回的，需要包一下
          result = {
            code: 200,
            message: 'success',
            data: r,
            contentType
          }
        }
      } else if (contentType.startsWith('image/')) {
        const blob = await response.blob()
        result = {
          code: 200,
          message: 'success',
          data: blob,
          contentType
        }
      } else if (contentType.includes('octet-stream')) {
         result = {
          code: 200,
          message: 'success',
          data: response,
          contentType
          }
      } else {
        result = {
          code: 200,
          message: 'success',
          data: await response.text(),
          contentType
        }
      }
      if (result.code == 401) {
        handleTokenExpired()
        return result
      }
      // 410：加密密码回退重试，静默
      // 403/409：终态错误，由业务跳转 /auth-fail 展示 message，此处不 toast
      // 400 及其他：toast 提示
      if (result.code !== 200 && result.code !== 410 && result.code !== 403 && result.code !== 409) {
        console.log(result)
        window.$message && window.$message.error(result.msg || result.message || '请求失败')
        return result
      }
      
      if (result.code === 200 && Array.isArray(result.data?.records) && result.data.records.length > 0) {
        result.data.records = result.data.records.map(item => {
          const { updateTime, updateBy, createBy,  ...rest } = item
          // createTime, 用户卡需要使用到创建时间字段 所以没筛除这个字段 
          return rest
        })
      }
      return result
    }catch (error) { 
      const errorMessage = (error && (error.message || String(error))) || '网络错误'
      window.$message && window.$message.error(errorMessage)
      return { 
        code: 500, 
        message: errorMessage, 
        data: null 
      }
    }
  }

  get(url, options) {
    return this.request(url, { ...options, method: 'GET' })
  }

  post(url, body, options) {
    return this.request(url, {
      ...options,
      method: 'POST',
      body: JSON.stringify(body)
    })
  }

  upload(url, params, options) {
    return this.request(url, {
      ...options,
      method: 'POST',
      body: params,
      isUpload: true
    })
  }

  put(url, body, options) {
    return this.request(url, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(body)
    })
  }

  patch(url, body, options) {
    return this.request(url, {
      ...options,
      method: 'PATCH',
      body: JSON.stringify(body)
    })
  }

  delete(url, body, options) {
    return this.request(url, { ...options, body: JSON.stringify(body), method: 'DELETE' })
  }

  query(url, params, options) {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : ''
    return this.request(url + queryString, { ...options, method: 'GET' })
  }

}

export default Request

const API_BASE = import.meta.env.VITE_API_BASE ?? '/proxy'
const FILE_BASE = import.meta.env.VITE_FILE_BASE || `/storage`

export const request = new Request(API_BASE, '/api')
export const file_request = new Request(FILE_BASE, '')


